export const INTERVIEW_SEGMENTS = [
  'greeting',
  'resumeWalkthrough',
  'technical',
  'strategicFit',
  'wrapUp',
] as const;

export type InterviewSegment = (typeof INTERVIEW_SEGMENTS)[number];

export const INTERVIEW_SEGMENT_TITLES: Record<InterviewSegment, string> = {
  greeting: 'Opening',
  resumeWalkthrough: 'Experience review',
  technical: 'Role skills',
  strategicFit: 'Work scenario',
  wrapUp: 'Wrap-up',
};
